import {createReducer, Reducer} from "redux-act";
import {IDictionary, IPrediction} from "modules/types";
import {fetchPredictionsSuccessAction} from "modules/actions";

const initialState: IDictionary<IPrediction> = {};
export const prediction_result: Reducer<IDictionary<IPrediction>> = createReducer({}, initialState);
prediction_result.on(fetchPredictionsSuccessAction, (state, payload) => payload);
